import { Output, Component, Input, EventEmitter, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "coworking-space-card",
  templateUrl: "./coworking-space-card.component.html",
  styleUrls: ["./coworking-space-card.component.scss"],
})
export class CoworkingSpaceCardComponent implements OnInit {
  constructor(private translate: TranslateService) {}
  price = [];
  priceType = ''
  publicPrice = null;
  @Input("space") space: any;
  @Input("selected") selected: any;
  @Output("click") click = new EventEmitter();

  ngOnInit() {
    this.price = this.space.durations.map((space) => space.label);
    this.getPrice();
  }

  public newClick() {
    this.click.emit(this.space);
  }

  get getSpaceCapacity() {
    if (this.space.type_id === 1 || this.space.type_id === 2) {
      return (
        this.space.available +
        " " +
        this.translate.instant("coworker.coworking-detail.spaces-min")
      );
    } else {
      return (
        this.space.capacity +
        " " +
        this.translate.instant("coworker.coworking-detail.places-min")
      );
    }
  }

  getPrice() {
      if (this.price.find(e => e == 'price_day')) {
        this.priceType = 'price_day'
        this.publicPrice = this.space.durations.find((space) => space.label == 'price_day').public_price;
      } else if (this.price.find(e => e == 'price_hour')) {
        this.priceType = 'price_hour'
        this.publicPrice = this.space.durations.find((space) => space.label == 'price_hour').public_price;
      } else if (this.price.find(e => e == 'price_week')) {
        this.priceType = 'price_week'
        this.publicPrice = this.space.durations.find((space) => space.label == 'price_week').public_price;
      } else if (this.price.find(e => e == 'price_month')) {
        this.priceType = 'price_month'
        this.publicPrice = this.space.durations.find((space) => space.label == 'price_month').public_price;
      }
  }
}
